import PersonalInfo from "@/pages/medewerkers/$userId/persoonlijke_gegevens/PersonalInfo"
import { can } from "@/utils/can"
import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute, useParams } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/beheer/medewerkers/$userId/persoonlijke_gegevens/",
)({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("read", "employees"),
})

function RouteComponent() {
  const { userId } = useParams({ from: "/beheer/medewerkers/$userId" })

  return (
    <PersonalInfo
      canEdit={can("update", "employees")}
      canEditRole={can("update", "employees")}
      userId={Number(userId)}
    />
  )
}
